import axios from 'axios'
import fn from '@/library/fn'
import { assign, each } from 'lodash'

const i18n = {
  t (val) { return val }
}
const loggedIn = () => !!localStorage.token

const process = (result) => {
  return new Promise((resolve, reject) => {
    const status = result.status || 200
    if (status === 202) {
      return reject({
        lang: 'accepted'
      })
    }
    resolve(result.data)
  })
}

const trimNull = (obj) => {
  const out = {}
  each(obj, (val, key) => {
    if (val !== null) Object.assign(out, { [key]: val })
  })
  return out
}

const checker = (res) => {
  let failRes = {
    code: 400,
    lang: 'nullResponse',
    asPopup: false,
    data: '',
    message: 'Failed to connect to server'
  }
  if (res === false) return failRes
  if (res === undefined) {
    failRes.lang = 'offline'
    return failRes
  }
  const status = res.status || 555

  let message = ''

  if (res.data.message) message = res.data.message
  else {
    switch (status) {
      case 404:
        message = 'Resource not found'
        break
      case 400:
        message = 'Invalid request'
        break
      default:
        message = 'Failed to connect to server'
        break
    }
  }

  return {
    status,
    lang: res.data.code,
    data: res.data.data,
    message
  }
}


const noty = (err) => {
  const check = checker(err.response)
  if (['exportReportAccepted', 'waitDownloadReport'].indexOf(check.lang) > -1) {
    fn.notySuccess(i18n.t('factory.' + check.lang))
  } else {
    fn.notyWarn(check.message)
  }
  return check
}

export const post = (url, data, headers = {}) => {
  return new Promise((resolve, reject) => {
    ajax({
      method: 'post',
      url,
      data,
      headers
    })
      .then(result => {
        return process(result)
      })
      .then(result => { resolve(result) })
      .catch(err => {
        const check = noty(err)
        reject(check)
      })
  })
}

export const loggedPost = (url, data, headers) => {
  if (!loggedIn()) return Promise.reject()
  data.accessToken = fn.token()
  data.companyId = fn.teamId()
  return post(url, data, headers)
}

export const put = (url, data, headers = {}) => {
  return new Promise((resolve, reject) => {
    ajax({
      method: 'put',
      url,
      data,
      headers
    })
      .then(result => {
        return process(result)
      })
      .then(result => { resolve(result) })
      .catch(err => {
        const check = noty(err)
        reject(check)
      })
  })
}

export const loggedPut = (url, data, headers) => {
  if (!loggedIn()) return Promise.reject()
  data.accessToken = fn.token()
  data.companyId = fn.teamId()
  return put(url, data, headers)
}

const del = (url, data) => {
  return new Promise((resolve, reject) => {
    ajax({
      method: 'delete',
      url,
      data: trimNull(data)
    })
      .then(result => {
        return process(result)
      })
      .then(result => { resolve(result) })
      .catch(err => {
        const check = noty(err)
        reject(check)
      })
  })
}

export const loggedDel = (url, data) => {
  if (!loggedIn()) return Promise.reject()
  data.accessToken = fn.token()
  data.companyId = fn.teamId()
  return del(url, data)
}

export const get = (url, params) => {
  return new Promise((resolve, reject) => {
    ajax({
      method: 'get',
      url,
      params
    })
      .then(result => {
        return process(result)
      })
      .then(result => { resolve(result) })
      .catch(err => {
        const check = noty(err)
        reject(check)
      })
  })
}

const dl = (url, params) => {
  return new Promise((resolve, reject) => {
    ajax({
      method: 'get',
      responseType: 'blob',
      url,
      params
    })
      .then(result => {
        return process(result)
      })
      .then(result => { resolve(result) })
      .catch(err => {
        const check = noty(err)
        reject(check)
      })
  })
}

export const dlGet = (url, params, rej) => {
  params.accessToken = fn.token()
  params.companyId = fn.teamId()
  return dl(url, params, rej)
}

export const loggedGet = (url, params) => {
  if (!loggedIn()) return Promise.reject()
  const prm = assign({}, params, { accessToken: fn.token(), companyId: fn.teamId() })
  return get(url, prm)
}

export const ajax = axios
